import React from "react";

import { FloatingMenu } from "@zapier/design-system";
import { Typeahead } from "@zapier/design-system";

import usStates, { USState } from "./usStates";

type StateSelectProps = {
  /** Show Error Styling */
  hasError?: boolean;
  /** Id of label element */
  labelId?: string;
  /** Handle item change */
  onChange: (value: USState) => void;
  /** Initial value */
  value?: string;
};

const StateSelect = ({
  hasError,
  labelId,
  onChange,
  value,
}: StateSelectProps) => {
  const initialValue = value ? usStates.find(c => c.code === value) : null;
  return (
    <Typeahead
      ariaLabel="state"
      filterItems={(inputValue, items) => {
        const lowerCaseInput = inputValue?.toLowerCase() || "";
        return items.filter(item =>
          `${item.name} ${item.code} ${item.alternativeSpellings}`
            .toLowerCase()
            .includes(lowerCaseInput)
        );
      }}
      getKeyForItem={(item: USState) => item.code}
      getLabelForItem={(item: USState) => item.name}
      initialSelectedItem={initialValue}
      isErrored={hasError}
      items={usStates}
      labelId={labelId}
      menuAriaLabel="address states"
      onChange={onChange}
      openOnFocus={true}
      placeholder="Select"
      renderFloatingMenu={props => (
        <FloatingMenu {...props} visibleItems={1.75} />
      )}
    />
  );
};

export default StateSelect;
